<template>
	<ul>
		<li v-for="item in items" :key="item.filename">
			<nuxt-link :to="item.filename">
				{{ item.header }}
			</nuxt-link>
			<div v-if="item.children.length">
				<recursive-sitemap :items="item.children" />
			</div>
		</li>
	</ul>
</template>

<script setup>
defineProps({
	items: { type: Array, default: () => [] },
});
</script>

<style lang="scss" scoped>
ul {
	padding: 5px 0 15px 20px;
}

:deep(a) {
	color: var(--color-velvet-hush);
}

:deep(a:hover),
:deep(li:hover) {
	color: var(--color-spicy-kiss);
}
</style>
